export const NAME = 'scellius';

export const REQUEST_SCELLIUS_FORM_TOKEN = 'REQUEST_SCELLIUS_FORM_TOKEN';
export const RECEIVE_SCELLIUS_FORM_TOKEN = 'RECEIVE_SCELLIUS_FORM_TOKEN';
export const FAILURE_SCELLIUS_FORM_TOKEN = 'FAILURE_SCELLIUS_FORM_TOKEN';

export const RESET_SCELLIUS = 'RESET_SCELLIUS';



// WEBPACK FOOTER //
// ./src/services/scellius/constants.js